// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1439":"ba57b596","1609":"6550c892","3346":"546e84a7","3771":"2ba2ccb8","8336":"2ba2ccb8"}[chunkId] + ".chunk.css";
};